<template>
  <div v-if="showPage403" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <b-card no-body>
      <b-card-header class="custom-header">
        <div>
          <i class="icon-note"></i>
          {{title}}
        </div>
        <b-button-group>
          <b-button v-on:click="redirectToList()" class="custom-cancel">
            <i class="fa fa-times text-danger"></i>
            &nbsp;Cancel
          </b-button>
          <b-button v-on:click="post('andClose')" :disabled="$v.form.$invalid || submitted">
            <i class="fa fa-save"></i>&nbsp;Save & Close
          </b-button>
          <b-button v-on:click="post()" :disabled="$v.form.$invalid || submitted">
            <i class="fa fa-check text-success"></i>&nbsp;Apply
          </b-button>
        </b-button-group>
      </b-card-header>

      <!-- Modal Component -->
      <div>
        <Modals ref="form"></Modals>
      </div>

      <b-card-body v-if="isLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <b-row>
          <b-col md="8">
            <b-tabs>
              <b-tab title="Details" active>
                <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
                  <b-row>
                    <b-col>
                      <!-- name -->
                      <b-form-group id="nameInputGroup1" 
                        label="Name" 
                        label-for="name"
                        label-class="font-weight-bold pt-0 required"
                      >
                        <b-form-input
                          id="Name"
                          type="text"
                          v-model.lazy.trim="$v.form.group_name.$model"
                          :state="chkState('group_name')"
                          aria-describedby="input1LiveFeedback1"
                          placeholder="Name"
                          autocomplete="given-name"
                          autofocus
                        />
                        <b-form-invalid-feedback
                          id="input1LiveFeedback1"
                        >This is a required field and must be at least 2 characters</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <!-- Description todo: use http://localhost:8081/editors/text-editors ?-->
                      <b-form-group>
                        <label 
                          for="description"
                          class="font-weight-bold"
                        >
                          Description
                        </label>
                        <b-form-textarea
                          cols="50"
                          id="basicTextarea"
                          :rows="3"
                          v-model.lazy.trim="$v.form.group_description.$model"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="group_id">
                    <b-col>
                      <label for="description">Settings</label>
                      <br />
                      <!--<router-link :to="'/settings/group/capabilities/'">
                        <b-button
                          v-b-toggle.collapse1
                          class="ml-1"
                          type="submit"
                          variant="outline-primary"
                        >
                          <i class="fa fa-wrench"></i>&nbsp;Capabilities
                        </b-button>
                      </router-link>-->
                      <router-link :to="'/settings/group/roles/'">
                        <b-button
                          v-b-toggle.collapse1
                          class="ml-1"
                          type="submit"
                          variant="outline-primary"
                        >
                          <i class="fa fa-gear"></i>&nbsp;Roles
                        </b-button>
                      </router-link>
                    </b-col>
                  </b-row>
                </b-form>
              </b-tab>

              <b-tab title="Capabilities">
                <div role="tablist">
                  <ul>
                    <li
                      class="li-custom-cap"
                      v-for="navItem in navItems" :key="navItem.id"
                    >
                      <b-form-checkbox
                        :id="
                          `nave_${navItem.id}_${navItem.name}_chk`
                        "
                        :name="
                          `nave_${navItem.id}_${navItem.name}_chk`
                        "
                        v-model="navItem.selected"
                        @change="updateData(navItem)"
                      >
                        <i
                          :class="
                            '' +
                              navItem.icon +
                              ' nav-icon font-sl d-inline-block'
                          "
                        ></i>
                        {{ navItem.name }}
                      </b-form-checkbox>
                    </li>
                  </ul>
                  <div v-for="navItem in navItems" :key="navItem.id">
                    <b-card v-if="navItem.selected">
                      <div slot="header">
                        <i :class="'' + navItem.icon + ' nav-icon font-sl d-inline-block'"></i>
                        {{navItem.name}}
                      </div>

                    
                      <div class="no-children-nav font-size-12" v-if="!navItem.children">
                        <ul>
                          <li class="li-custom-cap" v-for="capability in navItem.capabilities" :key="capability.id">
                            <b-form-checkbox
                              :id="`capability_${navItem.id}_${navItem.name}_chk_${capability.id}`"
                              :name="`capability_${navItem.id}_${navItem.name}_chk_${capability.id}`"
                              v-model="capability.value"
                            >
                              {{capability.label}}
                            </b-form-checkbox>
                          </li>
                        </ul>
                      </div>
                      <div class="has-children-nav font-size-12" v-else>
                        <ul>
                          <li
                            class="li-custom-cap"
                            v-for="navChild in navItem.children" :key="navChild.id"
                          >
                            <b-form-checkbox
                              :id="
                                `${navItem.name}_navChild_${navChild.id}_${navChild.name}_chk`
                              "
                              :name="
                                `${navItem.name}_navChild_${navChild.id}_${navChild.name}_chk`
                              "
                              v-model="navChild.selected"
                              @change="updateData(navChild)"
                            >
                              <i
                                :class="
                                  '' +
                                    navChild.icon +
                                    ' nav-icon font-sl d-inline-block'
                                "
                              ></i>
                              {{ navChild.name }}
                            </b-form-checkbox>
                          </li>
                        </ul>

                        <div v-for="navChild in navItem.children" :key="navChild.id">
                          <b-card v-if="navChild.selected">
                            <div slot="header">
                              <i :class="'' + navChild.icon + ' nav-icon font-sl d-inline-block'"></i>
                              {{navChild.name}}
                            </div>

                            <ul>
                              <li
                                class="li-custom-cap"
                                v-for="capability in navChild.capabilities"
                                :key="capability.id"
                              >
                                <b-form-checkbox
                                  :id="
                                    `capability_${navItem.id}_${navItem.name}_${navChild.id}_${navChild.name}_chk_${capability.id}`
                                  "
                                  :name="
                                    `capability_${navItem.id}_${navItem.name}_${navChild.id}_${navChild.name}_chk_${capability.id}`
                                  "
                                  v-model="capability.value"
                                >
                                  {{ capability.label }}
                                </b-form-checkbox>
                              </li>
                            </ul>

                          </b-card>
                        </div>
                      </div>
                    </b-card>
                  </div>



                </div>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { Switch as cSwitch } from "@coreui/vue";
import nav from "../../_nav.js";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { apigClient } from "@/shared/api";
import vSelect from "vue-select";
import Modals from "@/shared/Modals.vue";
import Page403 from "@/views/pages/Page403.vue";
import { router } from '@/router/index';

const Spinner = () => import("../shared/Spinner");
/*
sever side task:
we need

 - get the list of the existing groupd: url = /getGroups
 - delete a group: url =/deleteGroup/:id
 - get the name and the descripton of a group: url=/getGroup/:id
 - create a new group (name + description) and return the group id: url = /createGroup
 - update a group (name + description only): url = /updateGroup/:id
 - get the initial json capabilities Nav object containing the list of categories, pages and capabilities: url= /getNewGroupJson
 - update the json capabilities Nav object for a given group id: url= /updateGroupJson

*/

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};
miniToastr.init({ types: toastTypes });
function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

Vue.use(VueNotifications, options);

const formShape = {
  group_name: "",
  group_description: ""
};

let validations = {
  form: {
    group_name: {
      required,
      minLength: minLength(2)
    },
    group_description: {
      required: false
    }
  }
};

export default {
  name: "Group",
  components: {
    cSwitch,
    Spinner,
    vSelect,
    Modals,
    Page403
  },

  data() {
    // check route here, new or edit
    let newModePage = true;
    if (window.location.href.includes("/settings/group/edit")) {
      var group_id = localStorage.getItem("page_group_id");
      newModePage = false;
    }
    return {
      loginUserInfo: JSON.parse(localStorage.getItem("loginUserInfo")),
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      showPage403: false,
      newModePage: newModePage,
      title: "",
      navItems: JSON.parse(JSON.stringify(nav.items)),
      form: Object.assign({}, formShape),
      feedBack: "secondary",
      submitted: false,
      group_id: group_id || null,
      group_name: null,
      selected: null,
      //roles: roles,
      disabled: true,
      isLoading: true,
      rolesValid: false,
      showFeedBackRole: false
    };
  },

  created: function() {},

  mounted: function() {
    let that = this;  
    that.getPermission();
    if(that.newModePage && !that.permission.capabilities.Create){
      that.showPage403 = true;
      return;
    } else if ( !that.newModePage && !that.permission.capabilities.Edit){
      that.showPage403 = true;
      return;
    }

    if (that.group_id) {
      console.log(that.group_id)
      that.title = "Group - Edit";
      that.getGroupData();
    } else {
      that.loadNavMenusAndCapabilities();
      that.title = "Group - New";
      that.isLoading = false;
    }
  },
  computed: {
    formStr() {
      return JSON.stringify(this.form, null, 4);
    },
    isValid() {
      return !this.$v.form.$anyError;
    },
    isDirty() {
      return this.$v.form.$anyDirty;
    },

    classRoles: function() {
      return {
        valid: this.rolesValid,
        "not-valid": !this.rolesValid
      };
    },

    classRolesFeedBack: function() {
      return {
        show: !this.rolesValid
      };
    }
  },
  mixins: [validationMixin],
  validations: validations,
  methods: {
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === this.$route.meta.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        } 
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    updateData(navItem){
      let that = this;
      navItem.selected = !navItem.selected ? true : false;
      if(navItem.children){
        navItem.children.map(children => {
          children.selected = !navItem.selected ? false: children.selected;
          children.capabilities.map(cap => {
            cap.value = !children.selected ? false : cap.value;
            return cap;
          });
          return children;
        })
      }
      if(navItem.capabilities){
        navItem.capabilities.map(cap => {
          cap.value = !navItem.selected ? false : cap.value;
          return cap;
        });
      }
      that.$forceUpdate();
    },
    loadNavMenusAndCapabilities(existingGroupCapabilities = null){
      let that = this;
      that.navItems = that.navItems.map(navItem=>{
        if(!navItem.children){

          if(existingGroupCapabilities!=null){
            // Update Mode: Enable capabilities what is used to save before
            let navItemFromDB = existingGroupCapabilities.find(n=> n.id == navItem.id);
            if(navItemFromDB){
              navItem.capabilities = navItem.capabilities.map(navItemCapability => {
                let navItemCapabilityFromDB = navItemFromDB.capabilities.find(c => c.id == navItemCapability.id && c.name == navItemCapability.name);
                navItemCapability.value = (navItemCapabilityFromDB) ? navItemCapabilityFromDB.value : navItemCapability.value;
                return navItemCapability;
              });
            }
          }
          
          navItem.selected = navItem.capabilities.find(c => c.value) ? true : navItem.selected;
        } else{
          navItem.selected =false;

          let navItemFromDB = null;
          if(existingGroupCapabilities!=null){
            navItemFromDB = existingGroupCapabilities.find(n=> n.id == navItem.id);
          }
          navItem.children.forEach(childNav=>{

            if(navItemFromDB){
              // Update Mode: Enable capabilities what is used to save before
              let childNavFromDB = navItemFromDB.children.find(ch=> ch.id == childNav.id && ch.name == childNav.name);
              if(childNavFromDB){
                childNav.capabilities = childNav.capabilities.map(childNavItemCapability => {
                  let childNavItemCapabilityFromDB = childNavFromDB.capabilities.find(c => c.id == childNavItemCapability.id && c.name == childNavItemCapability.name);
                  childNavItemCapability.value = (childNavItemCapabilityFromDB) ? childNavItemCapabilityFromDB.value : childNavItemCapability.value
                  return childNavItemCapability;
                });
              }
            }

            childNav.selected = childNav.capabilities.find(c=> c.value) ? true : false;
          });

          navItem.selected = navItem.children.find(c=>c.selected) ? true : false;
        }
        return navItem;
      });
    },
    post: function(option) {
      let that = this;
      that.isLoading = true;
      // Checking duplication in group_name before create/update
      if (that.group_id) {
        that.$refs.form.openModal();
        that.changeModalContent(
          "loading",
          "Updating...",
          "Updating Group Info"
        );
        // Do PUT to API insert into Database
        let method = "PUT";
        let pathTemplate = "/groups/" + this.group_id;
        let additionalParams = {};
        let body = {
          groupName: that.form.group_name,
          groupDescription: that.form.group_description,
          groupCapabilities: that.navItems,
          updateBy: that.loginUserInfo.login_username
        };
        console.log(body);
        let pathParams = {};
        apigClient
          .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
          .then(function(result) {
            if (result.data.status) {
              console.log("update group, success");
              that.changeModalContent(
                "success",
                "Updated success!",
                "The Group data has been updated"
              );
              setTimeout(() => {
                that.$refs.form.closeModal();
              }, 2000);
              if (option == "andClose") {
                setTimeout(() => {
                  that.$router.push('/settings/groups');
                }, 2000);
              }
            } else {
              that.changeModalContent(
                "error",
                "Error Occured!",
                "Error From API Endpoint: " + result.data.message
              );
            }  
          })
          .catch(function(error) {
            that.changeModalContent("error", "Error Occured!", "Error From API Endpoint: " + error.message);
          });
      } else {
        that.$refs.form.openModal();
        that.changeModalContent("loading", "Saving...", "Saving Group Info");
        let method = "POST";
        let pathTemplate = "/groups";
        let additionalParams = {};
        let body = {
          groupName: that.form.group_name,
          groupDescription: that.form.group_description,
          groupCapabilities: that.navItems,
          createBy: that.loginUserInfo.login_username
        };
        let pathParams = {};
        apigClient
          .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
          .then(function(result) {
            if (result.data.status) {
              console.log(
                "create a new group, group_id: " + result["data"]["data"]
              );
              //that.showSuccessMsgCreate();
              that.changeModalContent(
                "success",
                "Saved success!",
                "The Group data has been created"
              );
              setTimeout(() => {
                that.$refs.form.closeModal();
              }, 2000);
              if (option == "andClose") {
                setTimeout(() => {
                  that.$router.push('/settings/groups');
                }, 2000);
              }
            } else {
              that.changeModalContent(
                "error",
                "Error Occured!",
                "Error From API Endpoint: " + result.data.message
              );
            }
          })
          .catch(function(error) {
            that.changeModalContent(
              "error",
              "Error Occured!",
              "Error From API Endpoint: " + error.message
            );
          });
      }
      this.isLoading = false;
    },
    routerBack() {
      this.$router.go(-1);
    },
    redirectToList() {
      let that = this;
      that.$router.push({ path: "/settings/groups" });
    },
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          // submit
          // console.log('submit:', this.formStr)
          this.submitted = true;
          this.feedBack = "info";
        });
      }
    },
    onReset() {
      // Reset validation
      this.form = Object.assign({}, formShape);
      this.submitted = false;
      this.$nextTick(() => {
        this.$v.$reset();
        this.feedBack = "secondary";
      });
    },
    chkState(val) {
      const field = this.$v.form[val];
      this.disabled = field.$model !== undefined && (
        this.$v.form['group_name'].$invalid
      );
      return (field.$model !== '' && field.$model !== undefined) ? !field.$dirty || !field.$invalid : null;
    },

    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus();
          return true;
        }
        if (component.$refs.check) {
          component.$refs.check.focus();
          return true;
        }
      }
      let focused = false;
      component.$children.some(child => {
        focused = this.findFirstError(child);
        return focused;
      });

      return focused;
    },
    validate() {
      this.$v.$touch();
      this.$nextTick(() => this.findFirstError());
      return this.isValid;
    },
    getGroupData: function() {
      var method = "GET";
      var pathTemplate = "/groups/" + this.group_id;
      var additionalParams = {};
      var pathParams = {};
      var groupData = [];
      var that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          console.log("result data=", result["data"]["data"]);
          groupData = result["data"]["data"];
          that.form.group_name = groupData.groupName;
          that.form.group_description = groupData.groupDescription=='NULL' ? '': groupData.groupDescription;
          that.isLoading = false;
          that.loadNavMenusAndCapabilities(groupData.groupCapabilities);
        })
        .catch(function(error) {
          console.log("ERROR ! Cannot get data:" + error);
          that.isLoading = false;
          //This is where you would put an error callback
        });
    },
    changeModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.form.status = status ? status : that.$refs.form.status;
      that.$refs.form.title = title ? title : that.$refs.form.title;
      that.$refs.form.message = message ? message : that.$refs.form.message;
    }
  },
  notifications: {
    showSuccessMsgCreate: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The group has been created"
    },
    showSuccessMsgUpdate: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The group has been updated"
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "Info",
      message: "Here is some info for you"
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "Warning",
      message: "That's the kind of warning"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "ERROR",
      message: "The group cannot be saved"
    }
  }
};
</script>


<style scoped>
.btn.disabled {
  cursor: auto;
}
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-group > .btn,
.btn-group-vertical > .btn {
  border: 1px solid #a4acb5;
}

@media only screen and (max-width: 600px) {
  .custom-header {
    flex-direction: column;
    align-items: inherit;
  }

  .custom-header > div:first-child {
    margin-bottom: 10px;
  }
}
.custom-cancel {
  border-radius: 0.25rem 0 0 0.25rem;
}

.sk-fading-circle .sk-circle {
  margin: 0 auto;
}
.sk-three-bounce {
  height: 40px;
}

.valid {
  border: 1px solid #4dbd74;
  border-radius: 0.25rem;
}

.not-valid {
  border: 1px solid #f86c6b;
  border-radius: 0.25rem;
}

.li-custom {
  list-style-type: none;
}
</style>

<style>
#language {
  margin-top: 15px;
}

select {
  /* for Firefox */
  -moz-appearance: none;
  /* for Chrome */
  -webkit-appearance: none;
}
/* For IE10 */
select::-ms-expand {
  display: none;
}

.v-select .dropdown-toggle {
  border: none !important;
}

.show {
  display: block;
}



ul {
  padding-left: 0;
}
.menu-title {
  font-size: 13px !important;
}
.li-custom-cap {
  list-style-type: none;
  display: inline-block;
  margin: 0px 15px 9px 0px;
}
.font-size-12{
  font-size: 12px !important;
}
.li-custom-cap .custom-control-label{
  padding-top:2px !important;
  font-size: 13px !important;
}
</style>